/* TGGCore: Trust-band footer behaviour (snippets/tgg-footer.liquid).
   1. Mobile accordions for the four menu columns (798px, the theme's medium-down query).
   2. Newsletter signup through Klaviyo's public client Subscriptions API so the
      list-triggered welcome flow fires; falls back to a plain form post if the
      request cannot be made.
   3. "Live chat" link opens the chat widget when one is present (Tidio API or a
      Shopify Inbox launcher) and otherwise follows its href.
   4. TGGCore: the brand line's Cormorant italic font loads only when the footer
      nears the viewport (perf). */
(function () {
  'use strict';

  var root = document.querySelector('[data-tgg-footer]');
  if (!root) return;

  /* ------------------------------------------------------- brand line font */
  /* TGGCore: perf. Switch the brand line to its Cormorant italic face only once
     the footer comes within ~800px of the viewport (see .tggf-serif-ready in
     tgg-footer.css), so the 40 KB font isn't fetched at top priority during
     page load. The class sits on <html> so a footer re-rendered in the theme
     editor keeps it. No IntersectionObserver: switch straight away. */
  (function serifWhenNear() {
    var html = document.documentElement;
    var READY = 'tggf-serif-ready';
    if (html.classList.contains(READY)) return;
    if (!('IntersectionObserver' in window)) {
      html.classList.add(READY);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          html.classList.add(READY);
          io.disconnect();
          return;
        }
      }
    }, { rootMargin: '800px 0px' });
    io.observe(root);
  })();

  var mq = window.matchMedia('(max-width: 798px)');

  /* ---------------------------------------------------------------- accordions */
  function setOpen(col, open) {
    col.classList.toggle('is-open', open);
    var btn = col.querySelector('.tggf__toggle');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function syncAria() {
    root.querySelectorAll('.tggf__col').forEach(function (col) {
      var btn = col.querySelector('.tggf__toggle');
      if (!btn) return;
      if (mq.matches) {
        btn.setAttribute('aria-expanded', col.classList.contains('is-open') ? 'true' : 'false');
      } else {
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  root.addEventListener('click', function (e) {
    var toggle = e.target.closest('.tggf__toggle');
    if (toggle) {
      if (!mq.matches) return;
      var col = toggle.closest('.tggf__col');
      setOpen(col, !col.classList.contains('is-open'));
      return;
    }
    var chat = e.target.closest('[data-tgg-chat-open]');
    if (chat) openChat(e);
  });

  if (mq.addEventListener) mq.addEventListener('change', syncAria);
  else if (mq.addListener) mq.addListener(syncAria);
  syncAria();

  /* ---------------------------------------------------------------- live chat */
  function openChat(e) {
    var tidio = window.tidioChatApi;
    if (tidio && typeof tidio.open === 'function') {
      e.preventDefault();
      if (tidio.show) tidio.show();
      tidio.open();
      return;
    }
    var inbox = document.querySelector('#ShopifyChat button, [data-shopify-chat] button, .shopify-chat__button');
    if (inbox) {
      e.preventDefault();
      inbox.click();
    }
    /* otherwise the link's href (contact page) is followed */
  }

  /* ---------------------------------------------------------------- newsletter */
  var form = root.querySelector('[data-tggf-klaviyo]');
  if (!form || !window.fetch) return;

  var status = root.querySelector('[data-tggf-status]');
  var input = form.querySelector('input[type="email"]');
  var button = form.querySelector('button[type="submit"]');

  function say(text, ok) {
    if (!status) return;
    status.textContent = text || '';
    status.classList.toggle('is-ok', !!ok);
    status.classList.toggle('is-error', !ok && !!text);
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (input && input.value || '').trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      say(status && status.getAttribute('data-error') || 'Please enter a valid email address.', false);
      if (input) input.focus();
      return;
    }
    var company = form.getAttribute('data-company');
    var list = form.getAttribute('data-list');
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: form.getAttribute('data-source') || 'Footer signup',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };

    if (button) button.disabled = true;
    say('', true);

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (res.status === 202 || res.ok) {
        say(status && status.getAttribute('data-success') || 'Thanks, you are on the list.', true);
        form.reset();
        if (window.dataLayer && window.dataLayer.push) {
          window.dataLayer.push({ event: 'tgg_footer_signup' });
        }
      } else {
        say(status && status.getAttribute('data-error') || 'Something went wrong. Please try again.', false);
      }
    }).catch(function () {
      say(status && status.getAttribute('data-error') || 'Something went wrong. Please try again.', false);
    }).then(function () {
      if (button) button.disabled = false;
    });
  });
})();
